import TakeQuizPage from "./TakeQuizPage";

export default TakeQuizPage;